import { render, staticRenderFns } from "./UnfavoriteChip.vue?vue&type=template&id=5569f5fe&scoped=true&"
import script from "./UnfavoriteChip.vue?vue&type=script&lang=js&"
export * from "./UnfavoriteChip.vue?vue&type=script&lang=js&"
import style0 from "./UnfavoriteChip.vue?vue&type=style&index=0&id=5569f5fe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5569f5fe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
